import ImportTypeCard from './ImportTypeCard';

export default ImportTypeCard;
